import { createFetchReducer } from '../helpers/fetchData'
import actions from './actions'

const brand = createFetchReducer({ name: actions.brandApiName })

export default brand
